import axios from "axios";

export const getOwnInvoicesByStatus = async (idCompany) => {
  const hostname = window.location.hostname.includes("localhost")
    ? "localhost"
    : "unioninformatica.org";

  const url = `http://${hostname}:4000/api/v1/boletaDigital/getOwnInvoicesByStatus?idCompany=${idCompany}`;

  try {
    const { data } = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { data };
  } catch (error) {
    console.error("Error en getOwnInvoicesByStatus:", error);
    return { data: [] }; // Devolvemos array vacío para evitar errores en frontend
  }
};
